import "phaser";
import { cst } from "../helpers/cst";
import buttonBehaviours from "../helpers/button-behaviours";
import { Controller } from "../controller/controller.js";
import Board from "./board";

export default class GUI extends Phaser.Scene {
  constructor() {
    super(cst.scenes.gui);
  }

  create(scene) {
    this.scene.bringToTop();

    this.add
      .rectangle(0, 0, 1000, 100, 0xffffff, 1)
      .setOrigin(0, 0)
      .setScrollFactor(0);

    this.add
      .rectangle(0, 1180, 1000, 200, 0xffffff, 1)
      .setOrigin(0, 0)
      .setScrollFactor(0);

    scene.txtScore = this.add
      .text(
        this.cameras.main.width / 2 + 6,
        this.cameras.main.height / 2 - 645,
        `Score: ${scene.player.score}`,
        cst.textstyles.points
      )
      .setOrigin(0.5, 0);

    scene.btnRules = this.add
      .image(
        this.cameras.main.width / 2 + 270,
        this.cameras.main.height / 2 + 585,
        "btn-rules"
      )
      .setInteractive({
        useHandCursor: true,
      })
      .on("pointerdown", () => {
        buttonBehaviours.pushOnClick(this, scene.btnRules, () => {
          this.scene.pause();
          this.scene.launch(cst.scenes.rules, {
            scene: cst.scenes.gui,
          });
        });
      })
      .setScale(1.4)
      .setScrollFactor(0);

    scene.btnPause = this.add
      .image(
        this.cameras.main.width / 2 - 270,
        this.cameras.main.height / 2 + 585,
        "btn-pause"
      )
      .setInteractive({
        useHandCursor: true,
      })
      .on("pointerdown", () => {
        buttonBehaviours.pushOnClick(this, scene.btnPause, () => {
          this.scene.pause();
          this.scene.launch(cst.scenes.pause, {
            scene: cst.scenes.gui,
          });
        });
      })
      .setScale(1.4)
      .setScrollFactor(0);

    scene.boxDice = this.add
      .sprite(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 - 100,
        "box-dice"
      )
      .setScale(1)
      .setVisible(false)
      .setScrollFactor(0);

    scene.dice = this.add
      .sprite(
        this.cameras.main.width / 2 - 75,
        this.cameras.main.height / 2 - 100,
        "sprite-dice"
      )
      .setScale(0.8)
      .setVisible(false)
      .setScrollFactor(0);

    scene.dice2 = this.add
      .sprite(
        this.cameras.main.width / 2 + 75,
        this.cameras.main.height / 2 - 100,
        "sprite-dice"
      )
      .setScale(0.8)
      .setVisible(false)
      .setScrollFactor(0);

    scene.chest = this.add
      .sprite(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 - 100,
        "win-sprite"
      )
      .setScale(0.8)
      .setVisible(false)
      .setScrollFactor(0);

    scene.btnRoll = this.add
      .image(
        this.cameras.main.width / 2,
        this.cameras.main.height / 2 + 585,
        "btn-roll"
      )
      .setInteractive({
        useHandCursor: true,
      })
      .setScale(1.1)
      .on("pointerdown", () =>
        buttonBehaviours.pushOnClick(this, scene.btnRoll, () => {
          scene.controller.rollDice();
        })
      )
      .setScrollFactor(0, 0);

    // Animations
    scene.anims.create({
      key: "sprite-dice-roll",
      frames: scene.anims.generateFrameNames("sprite-dice-roll"),
      frameRate: 8,
      repeat: 1,
    });

    scene.anims.create({
      key: "win-sprite",
      frames: scene.anims.generateFrameNames("win-sprite"),
      frameRate: 8,
      repeat: 0,
    });

    // On resume event
    this.events.on("resume", (scene, data) => {
      this.scene.bringToTop();
      if (data.showChest == true) {
        scene.chest.setVisible(true);
        scene.chest.play("win-sprite");
        setTimeout(() => {
          scene.chest.setVisible(false);
        }, 1500);
      }

      if (data.scene !== cst.scenes.rules && data.scene !== cst.scenes.pause) {
        this.scene.bringToTop();
        scene.btnRoll.setInteractive();
        scene.btnRules.setInteractive();
        scene.btnPause.setInteractive();
        scene.btnRoll.setVisible(true);
        scene.btnRules.setVisible(true);
        scene.btnPause.setVisible(true);
        // this line causes error sometimes
        if (scene.config.numberCategories >= 2) {
          scene.categoriesLog[`${data.category}`].questions++;
        }

        if (data.isCorrect) {
          scene.player.score = scene.player.score + data.points;
          scene.txtScore.text = "Score: " + scene.player.score;

          // this line causes error
          if (scene.config.numberCategories >= 2) {
            scene.categoriesLog[`${data.category}`].correct++;
          }
        }

        if (scene.end) {
          scene.controller.fireworks(false);
        } else {
          scene.btnRoll.setTexture("btn-roll");
          scene.btnRoll.setInteractive();
          scene.btnRules.setInteractive();
          scene.btnPause.setInteractive();
          scene.btnRoll.setVisible(true);
          scene.btnRules.setVisible(true);
          scene.btnPause.setVisible(true);
        }
      }
    });
  }

  update() {}
}
